import { TimelineData } from "./Types";
import { Box, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useCommunityNavigation } from "@infrastructure/Hooks/useCommunityNavigation";
import { useGameGeneralState } from "../Hooks/useGameGeneralState";
import { WATCH_APP_GAME_URL, WatchAppApiStatusType } from "../Service";
import { useGameUrl } from "../Hooks/useGameUrl";

export function GameLinkout({
    timeline,
    watchAppApiStatus,
}: {
    timeline?: TimelineData;
    watchAppApiStatus?: WatchAppApiStatusType;
}) {
    const { navigateTo } = useCommunityNavigation();
    const gameState = useGameGeneralState(timeline);
    const [label, url] = useGameUrl(gameState, timeline, watchAppApiStatus);

    if (label === undefined) {
        return null;
    }

    return (
        <Box
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
            }}
        >
            <Stack
                direction={"row"}
                onClick={(e) => {
                    e.stopPropagation();

                    navigateTo(
                        WATCH_APP_GAME_URL.replace(
                            ":gameId",
                            timeline!.sportEvent.id.toString(),
                        ) + url,
                    );
                }}
                alignItems={"center"}
            >
                <Typography
                    style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "var(--community-color-bright-azure)",
                    }}
                >
                    {label}
                </Typography>
            </Stack>
        </Box>
    );
}
